import { Col, Row, Container } from "reactstrap";
import {
  JustifiedText,
  PreviousEditionsContainer,
} from "./PreviousEditions.stylesheets";
import { useTranslation } from "react-i18next";

export const PreviousEditionsContent = () => {
  const { t } = useTranslation();

  return (
    <PreviousEditionsContainer className="vertical-content">
      <Container>
        {/* Título principal de la sección */}
        <Row className="mb-5">
          <Col>
            <h1 className="text-center page-title" style={{ 
              color: '#333333',
              fontWeight: 'bold',
              marginBottom: '2rem'
            }}>
              {t("EDICIONES ANTERIORES")}
            </h1>
            <p className="text-center lead page-subtitle" style={{ color: '#666666' }}>
              {t("¡Conoce la historia del Congreso Espacial Centroamericano!")}
            </p>
          </Col>
        </Row>

        {/* Bloque 1: CEC 2023 */}
        <Row className="align-items-center mb-5 py-4">
          <Col lg="6" className="mb-4 mb-lg-0">
            <h3 className="edition-title" style={{ 
              color: '#000000 !important',
              fontSize: '2rem',
              fontWeight: 'bold',
              marginBottom: '1.5rem'
            }}>
              <span style={{ color: '#000000' }}>CEC 2023</span>
            </h3>
            <JustifiedText className="edition-text" style={{ color: '#555555', lineHeight: '1.8' }}>
              {t("previousEditionsInfo2023")}
            </JustifiedText>
            <JustifiedText className="edition-text" style={{ color: '#555555', marginTop: '1rem' }}>
              {t("Más información del CEC 2023 en el siguiente enlace:")}
            </JustifiedText>
            <a
              href="https://cec-2023.sitrus.ai/"
              className="btn btn-primary mt-3"
              target="_blank"
              rel="noreferrer"
              style={{
                padding: '10px 30px',
                fontWeight: '600',
                letterSpacing: '0.5px',
                boxShadow: '0 4px 15px rgba(0, 123, 255, 0.3)',
                transition: 'all 0.3s ease'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 123, 255, 0.4)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 123, 255, 0.3)';
              }}
            >
              {t("Visitar sitio CEC 2023")}
            </a>
          </Col>
          <Col lg="6">
            <div className="image-container" style={{
              overflow: 'hidden',
              borderRadius: '10px',
              boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
              transition: 'transform 0.3s ease'
            }}
            onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
            onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
            >
              <img
                src="/assets/images/cec2023.png"
                className="img-fluid"
                alt="CEC SPACE 2023"
                style={{ width: '100%', height: 'auto' }}
              />
            </div>
            <p className="fw-light text-end mt-3" style={{ 
              color: '#777777',
              fontSize: '0.9rem',
              fontStyle: 'italic'
            }}>
              {t("Participantes del CEC 2023 afuera del Aula Magna de la UCR")}
              <br />
              {t("Créditos de la fotografía: Andrés Mora")}
            </p>
          </Col>
        </Row>

        <hr style={{ 
          margin: '3rem 0',
          border: 'none',
          borderTop: '2px solid #e0e0e0'
        }} />

        {/* Bloque 2: CEC 2024 */}
        <Row className="align-items-center mb-5 py-4">
          <Col lg="6" className="order-lg-2 mb-4 mb-lg-0">
            <h3 className="edition-title" style={{ 
              color: '#000000 !important',
              fontSize: '2rem',
              fontWeight: 'bold',
              marginBottom: '1.5rem'
            }}>
              <span style={{ color: '#000000' }}>CEC 2024</span>
            </h3>
            <JustifiedText className="edition-text" style={{ color: '#555555', lineHeight: '1.8' }}>
              {t("previousEditionsInfo2024")}
            </JustifiedText>
            <JustifiedText className="edition-text" style={{ color: '#555555', marginTop: '1rem' }}>
              {t("Más información del CEC 2024 en el siguiente enlace:")}
            </JustifiedText>
            <a
              href="https://noticias.uvg.edu.gt/mas-de-400-personas-de-21-paises-asistieron-al-ii-congreso-espacial-centroamericano-2024-con-sede-en-uvg/"
              className="btn btn-success mt-3"
              target="_blank"
              rel="noreferrer"
              style={{
                padding: '10px 30px',
                fontWeight: '600',
                letterSpacing: '0.5px',
                boxShadow: '0 4px 15px rgba(40, 167, 69, 0.3)',
                transition: 'all 0.3s ease'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(40, 167, 69, 0.4)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(40, 167, 69, 0.3)';
              }}
            >
              {t("Leer noticia CEC 2024")}
            </a>
          </Col>
          <Col lg="6" className="order-lg-1">
            <div className="image-container" style={{
              overflow: 'hidden',
              borderRadius: '10px',
              boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
              transition: 'transform 0.3s ease'
            }}
            onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
            onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
            >
              <img
                src="/assets/images/cec2024.jpg"
                className="img-fluid"
                alt="CEC SPACE 2024"
                style={{ width: '100%', height: 'auto' }}
              />
            </div>
            <p className="fw-light mt-3" style={{ 
              color: '#777777',
              fontSize: '0.9rem',
              fontStyle: 'italic'
            }}>
              {t("Participantes del CEC 2024 en la Plaza del CIT de la UVG")}
              <br />
              {t("Créditos de la fotografía: UVG")}
            </p>
          </Col>
        </Row>

        {/* Sección CTA para CEC 2026 */}
        <Row className="mt-5">
          <Col>
            <div className="text-center p-5 cta-section" style={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              borderRadius: '15px',
              color: 'white',
              boxShadow: '0 15px 35px rgba(0,0,0,0.15)'
            }}>
              <h3 className="mb-3" style={{ 
                fontWeight: 'bold',
                color: '#ffffff !important' 
              }}>
                {t("¡Prepárate para el CEC 2026!")}
              </h3>
              <p className="lead mb-4" style={{ color: '#ffffff !important' }}>
                {t("La tercera edición será nuevamente en la Ciudad de Guatemala del 16 al 18 de septiembre de 2026.")}
              </p>
              <a
                href="/"
                className="btn btn-light btn-lg px-5"
                style={{
                  fontWeight: '600',
                  letterSpacing: '0.5px',
                  color: '#764ba2'
                }}
              >
                {t("Volver al inicio")}
              </a>
            </div>
          </Col>
        </Row>
      </Container>
      
      {/* Estilos específicos para sobrescribir cualquier CSS global */}
      <style jsx>{`
        .edition-title {
          color: #000000 !important;
        }
        
        .edition-title span {
          color: #000000 !important;
        }
        
        .page-title {
          color: #333333 !important;
        }
        
        .page-subtitle {
          color: #666666 !important;
        }
        
        .edition-text {
          color: #555555 !important;
        }
        
        .cta-section h3 {
          color: #ffffff !important;
        }
        
        .cta-section p {
          color: #ffffff !important;
        }
      `}</style>
    </PreviousEditionsContainer>
  );
};